var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full"},[_c('iframe',{staticClass:"w-full h-full",attrs:{"src":("/lib/pdfjs/web/viewer.html?file=" + _vm.fileUrl + "#page=1&zoom=70"),"id":"mainPdfIframe"},on:{"load":_vm.fileLoaded}})])}
var staticRenderFns = []

export { render, staticRenderFns }